var RequestHandler = /** @class */ (function () {
    function RequestHandler() {
    }
    RequestHandler.setServerToken = function (token) {
        this._token = token;
    };
    RequestHandler.setServerRefreshToken = function (refreshToken) {
        this._refreshToken = refreshToken;
    };
    RequestHandler.setServerExpired = function (expired) {
        this._expired = expired;
    };
    RequestHandler.setServerAgent = function (userAgent) {
        this._userAgent = userAgent;
    };
    RequestHandler.getServerToken = function () {
        return this._token;
    };
    RequestHandler.getServerRefreshToken = function () {
        return this._refreshToken;
    };
    RequestHandler.getServerExpired = function () {
        return this._expired;
    };
    RequestHandler.getServerAgent = function () {
        return this._userAgent;
    };
    return RequestHandler;
}());
export default RequestHandler;
